// Initial state 
const state = {
    isEditProductCategory: false,
    productCategoryId: 0,
    isEditWarehouse: false,
    warehouseId: 0,
    isEditProduct: false,
    productId: 0,
    // Purchase Order
    POProductsDetailsDS: [],
    POGridDataItem: {},
    isEditPOGrid: false,
    isEditPO: false,
    isValidatePO: false,
    IsRejectedPO:false,
    IsEditPurchaseOrderBYID: 0,
    // Vendor Group
    vendorGroupId: 0,
    isEditVendorGroup: false,
    isEditVendor: false,
    vendorId: 0,
    //Internal Request
    internalRequestId: 0,
    isEditInternalRequest: false,
    isViewInternalRequest: false,
    viewInternalRequestID: 0,
    // purchase Requisition
    purchaseRequisitionIsEditMode: false,
    purchaseRequisitionId: 0,
    // purchase Order
    purchaseOrderIsEditMode: false,
    purchaseOrderId: 0,
    isViewModePO: false,
    // Goods Receipt
    isViewModeGR: false,
    isEditModeGR:false,
    // Transfer Out
    isViewTransferOut: false,
    isEditTransferOut:false,
    transferOutID: 0,
    goodsReceiptID: 0,
    goodsReceiptViewID: 0,
    // Transfer In

    isViewTransferIn: false,
    transferInID: 0,

    // returns
    returnTransactionID: 0,
    isViewReturnTransaction: false,

    // Return to vendor
    isViewReturnToVendor: false,
    returnToVendorID: 0,
    isEditRTV: false,
    EditRTVID: 0,

    //// Receive IR 
    receiveInternalRequestID: 0,

    // Stock Count
    isViewStockCount: false,
    isEditStockCount: false,
    stockCountID: 0,

    // Manufacturing Order
    isViewMO: false,
    MOID: 0,

    //Donation
    isViewDonation: false,
    DonationID: 0,

    // warehouse location 
    WHLocationID: 0,
    isEditWHLocation: false,

    //Internal Transfer btn locations
    isViewInternalTransfer: false,
    InternalTransferID: 0,
};

// Update Data "mutations"
const mutations = {
    updateIsEditProductCategory(state, value) {
        state.isEditProductCategory = value;
    },
    updateIsEditProductCategoryBYID(state, id) {
        state.productCategoryId = id;
    },
    updateIsEditWarehouse(state, value) {
        state.isEditWarehouse = value;
    },
    updateIsEditWarehouseBYID(state, id) {
        state.warehouseId = id;
    },
    updateIsEditProduct(state, value) {
        state.isEditProduct = value;
    },
    updateIsEditProductBYID(state, id) {
        state.productId = id;
    },
    // Purchase Order
    POProductsDetails(state, value) {
        state.POProductsDetailsDS.unshift(value);
    },
    updatePOProductsDetailsDS(state, payload) {
        state.POProductsDetailsDS[payload.rowIndex] = payload.ProductsDetails;
    },
    ResetPOProductsDetailsGrid(state, value) {
        state.POProductsDetailsDS = value;
    },
    POGridDataItem(state, value) {
        state.POGridDataItem = value
    },
    isEditPOGrid(state, value) {
        state.isEditPOGrid = value
    },

    // Vendor Group
    setIsEditVendorGroup(state, value) {
        state.isEditVendorGroup = value;
    },
    setVendorGroupId(state, id) {
        state.vendorGroupId = id;
    },
    // Vendor
    setIsEditVendor(state, value) {
        state.isEditVendor = value;
    },
    setVendorId(state, id) {
        state.vendorId = id;
    },
    // Internal Request
    setIsEditInternalRequest(state, value) {
        state.isEditInternalRequest = value;
    },
    setInternalRequestId(state, id) {
        state.internalRequestId = id;
    },
    updateIsViewInternalRequest(state, value) {
        state.isViewInternalRequest = value;
    },
    updateInternalRequestID(state, id) {
        state.viewInternalRequestID = id;
    },
    // purchase Requisition
    setPurchaseRequisitionIsEditMode(state, value) {
        state.purchaseRequisitionIsEditMode = value;
    },
    setPurchaseRequisitionId(state, id) {
        state.purchaseRequisitionId = id;
    },
    //  Purchase Order
    updateIsEditPO(state, value) {
        state.isEditPO = value;
    },
    updateIsValidatePO(state, value) {
        state.isValidatePO = value;
    },
    updateIsRejectedPO(state, value) {
        state.IsRejectedPO = value;
    },
    updateIsEditPurchaseOrderBYID(state, value) {
        state.IsEditPurchaseOrderBYID = value
    },
    updateIsViewPO(state, value) {
        state.isViewModePO = value;
    },
    // Goods Receipt
    updateIsViewGR(state, value) {
        state.isViewModeGR = value;
    },
    updateIsEditGR(state, value) {
        state.isEditModeGR = value;
    },
    updateIsEditGRID(state, value) {
        state.goodsReceiptID = value
    },
    updateIsViewPurchaseOrderID(state, value) {
        state.purchaseOrderId = value
    },
    // Transfer Out
    updateIsViewTransferOut(state, value) {
        state.isViewTransferOut = value
    },
    updateTransferOutID(state, value) {
        state.transferOutID = value
    },
    updateIsEditTransferOut(state, value) {
        state.isEditTransferOut = value
    },
    updateIsViewGRID(state, value) {
        state.goodsReceiptViewID = value
    },
    // Transfer In
    updateIsViewTransferIn(state, value) {
        state.isViewTransferIn = value
    },
    updateIsViewTransferInID(state, value) {
        state.transferInID = value
    },

    // returns
    updateReturnTransactionID(state, value) {
        state.returnTransactionID = value
    },
    updateIsViewReturnTransaction(state, value) {
        state.isViewReturnTransaction = value
    },

    // Return to vendor 
    updateIsViewReturnToVendor(state, value) {
        state.isViewReturnToVendor = value
    },
    updateReturnToVendorID(state, value) {
        state.returnToVendorID = value
    },
    updateIsEditRTV(state, value) {
        state.isEditRTV = value
    },
    updateEditRTVID(state, value) {
        state.EditRTVID = value
    },

    //// Receive IR
    updateReceiveInternalRequestID(state, value) {
        state.receiveInternalRequestID = value
    },

    // Stock Count
    updateIsViewStockCount(state, value) {
        state.isViewStockCount = value
    },
    updateStockCountID(state, value) {
        state.stockCountID = value
    },
    updateIsEditStockCount(state, value) {
        state.isEditStockCount = value
    },

    // Manufacturing Orders
    updateIsViewMO(state, value) {
        state.isViewMO = value
    },
    updateMOID(state, value) {
        state.MOID = value
    },
    //Donations
    updateDonationID(state, value) {
        state.DonationID = value;
    },
    updateIsViewDonation(state, value) {
        state.isViewDonation = value
    },
    // WareHouse Location (new location screen )
    updateWHLocationID(state, value) {
        state.WHLocationID = value
    },
    updateIsEditWHLocation(state, value) {
        state.isEditWHLocation = value
    },

    //Internal Transfer btn locations 
    updateInternalTransferID(state, value) {
        state.InternalTransferID = value;
    },
    updateIsViewInternalTransfer(state, value) {
        state.isViewInternalTransfer = value
    },
};

// Get data
const getters = {
    getIsEditProductCategory: state => {
        return state.isEditProductCategory
    },
    getProductCategoryId: state => {
        return state.productCategoryId
    },
    getIsEditWarehouse: state => {
        return state.isEditWarehouse
    },
    getWarehouseId: state => {
        return state.warehouseId
    },
    getIsEditProduct: state => {
        return state.isEditProduct
    },
    getProductId: state => {
        return state.productId
    },
    // Purchase Order
    getPOProductsDetailsDS: state => {
        return state.POProductsDetailsDS
    },
    getPOGridDataItem: state => {
        return state.POGridDataItem
    },
    getisEditPOGrid: state => {
        return state.isEditPOGrid
    },
    getIsEditPO: state => {
        return state.isEditPO
    },
    getIsValidatePO: state => {
        return state.isValidatePO
    },
    getIsRejectedPO: state => {
        return state.IsRejectedPO
    },
    getIsEditPurchaseOrderBYID: state => {
        return state.IsEditPurchaseOrderBYID
    },
    // Vendor Group
    getIsEditVendorGroup: state => {
        return state.isEditVendorGroup
    },
    getVendorGroupId: state => {
        return state.vendorGroupId
    },
    getIsEditVendor: state => {
        return state.isEditVendor
    },
    getVendorId: state => {
        return state.vendorId
    },
    // Internal Request
    getIsEditInternalRequest: state => {
        return state.isEditInternalRequest
    },
    getInternalRequestId: state => {
        return state.internalRequestId
    },
    getIsViewInternalRequest: state => {
        return state.isViewInternalRequest
    },
    getViewInternalRequestID: state => {
        return state.viewInternalRequestID
    },
    // purchase Requisition
    getIsEditPurchaseRequisition: state => {
        return state.purchaseRequisitionIsEditMode
    },
    getPurchaseRequisitionId: state => {
        return state.purchaseRequisitionId
    },
    // purchase Order
    getIsEditPurchaseOrder: state => {
        return state.purchaseOrderIsEditMode
    },
    getPurchaseOrderId: state => {
        return state.purchaseOrderId
    },
    getIsViewPO: state => {
        return state.isViewModePO
    },
    // Goods Receipt
    getIsViewGR: state => {
        return state.isViewModeGR
    },
    getIsEditGR: state => {
        return state.isEditModeGR
    },
    // transfer out
    getIsViewTransferOut: state => {
        return state.isViewTransferOut
    },
    getIsEditTransferOut: state => {
        return state.isEditTransferOut
    },
    getTransferOutId: state => {
        return state.transferOutID
    },
    getGoodsReceiptId: state => {
        return state.goodsReceiptID
    },
    getViewGoodsReceiptId: state => {
        return state.goodsReceiptViewID
    },
    getIsViewTransferIn: state => {
        return state.isViewTransferIn
    },
    getTransferInId: state => {
        return state.transferInID
    },
    // returns
    getReturnTransactionID: state => {
        return state.returnTransactionID
    },

    getIsViewReturnTransaction: state => {
        return state.isViewReturnTransaction
    },

    // Return to vendor 
    getIsViewReturnToVendor: state => {
        return state.isViewReturnToVendor
    },
    getReturnToVendorID: state => {
        return state.returnToVendorID
    },
    getIsEditRTV: state => {
        return state.isEditRTV
    },
    getEditRTVID: state => {
        return state.EditRTVID
    },

    // receive IR 
    getReceiveInternalRequestID: state => {
        return state.receiveInternalRequestID
    },

    // Stock Count
    getIsViewStockCount: state => {
        return state.isViewStockCount
    },
    getIsEditStockCount: state => {
        return state.isEditStockCount
    },
    getStockCountId: state => {
        return state.stockCountID
    },
    // Manufacturing Orders
    getIsViewMO: state => {
        return state.isViewMO 
    },
    getMOID: state => {
        return state.MOID
    },
    //Donation
    getDonationID: state => state.DonationID,
    getIsDonationView: state => state.isViewDonation,

    // WH location 
    getIsEditWHLocation: state => state.isEditWHLocation,
    getWHLocationID: state => state.WHLocationID,

    //Internal Transfer btn locations
    getInternalTransferID: state => state.InternalTransferID,
    getIsInternalTransferView: state => state.isViewInternalTransfer,
};

export default {
    mutations,
    state,
    getters
};

//import { reflectKeys } from '@/app/shared/services';

//import { fetchInventory } from '../services/inventory-management/inventory-management.js';
//import Axios from 'axios';

///** Initial state */
//const initialState = {
//  loading: false,
//  data: null,
//  error: null,
//  productsData: []
//};

///** Prefix for mutation types and actiontypes */
//const namespacedPrefix = '[INVENTORY]';

///**
// * Mutation types
// */
//const mutationTypes = reflectKeys(
//  [
//    'INVENTORY_DATA_SUCCESS',
//    'INVENTORY_DATA_REQUEST',
//    'INVENTORY_DATA_ERROR',
//    'INVENTORY_DATA_RESET'
//  ],
//  namespacedPrefix
//);

//const {
//  INVENTORY_DATA_ERROR,
//  INVENTORY_DATA_REQUEST,
//  INVENTORY_DATA_RESET,
//  INVENTORY_DATA_SUCCESS
//} = mutationTypes;

///**
// * Users data mutations
// */
//const mutations = {
//  // products data
//  getProductsData(state, response) { 
//    state.productsData = response.data;
//  },

//  /** user data request */
//  [INVENTORY_DATA_REQUEST](state) {
//    Object.assign(state, { loading: true, error: null });
//  },

//  /** user data success */
//  [INVENTORY_DATA_SUCCESS](state, payload) {
//    Object.assign(state, { loading: false, data: payload });
//  },

//  /** user data error */
//  [INVENTORY_DATA_ERROR](state, payload) {
//    Object.assign(state, {
//      loading: false,
//      data: null,
//      error: payload || true
//    });
//  },

//  /** reset user data */
//  [INVENTORY_DATA_RESET](state) {
//    Object.assign(state, ...initialState);
//  }
//};

//// get products data
//const getters = {
//  getProducts: state => { 
//    return state.productsData
//  }
//};

///** Actions types constants */
//export const actionsTypes = reflectKeys(['FETCH_INVENTORY_DATA'], namespacedPrefix);

///**
// * INVENTORY data actions
// */
//const actions = {
//  // Fetch products data
//  getProductsData(state) {
//    return Axios.get('http://localhost:8080/mock-data/product.json')
//                .then(response => { 
//                  state.commit('getProductsData', response)
//                }).catch(error => console.log(error))
//  },
//  /** fetch INVENTORY data */
//  async [actionsTypes.FETCH_INVENTORY_DATA](context, authCred) {
//    context.commit(INVENTORY_DATA_REQUEST);

//    const result = await fetchInventory(authCred).catch(e => {
//      context.commit(INVENTORY_DATA_ERROR, e);
//    });

//    if (result) {
//      context.commit(INVENTORY_DATA_SUCCESS, result);
//    }

//    return result;
//  }
//};

//export default {
//  mutations,
//  actions,
//  state: initialState,
//  getters
//};
